<script lang="ts">
  import UserMenuDropdown from '@components/navigation/UserMenuDropdown.svelte'
  import {
    signedInMenuItems,
    signedOutMenuItems,
    userMenuOptions,
    excludeHeaderLinks,
    withReturnTo,
  } from '@components/navigation/user_menu'
  import { watchUserHomeHub } from 'frontend/inertia/stores/user_home_hub.svelte'
  import { down } from 'shared/javascripts/util/breakpoints'
  import { isNativeApp } from 'shared/javascripts/util/detection'
  import type { UserMenuData } from './types'

  const { user, studybuddyMenuVisible, withoutHeaderLinks }: UserMenuData = $props()

  let currentPath = $state(location.pathname)
  let mobileLayout = $state(false)

  $effect(() => watchUserHomeHub())

  $effect(() =>
    up.on('up:location:changed', () => {
      currentPath = location.pathname
    }),
  )

  $effect(() => {
    const query = window.matchMedia(down('header-medium'))
    const update = () => (mobileLayout = query.matches)
    update()
    query.addEventListener('change', update)
    return () => query.removeEventListener('change', update)
  })

  const items = $derived.by(() => {
    const options = { ...userMenuOptions(), studybuddyMenuVisible }

    if (user) return signedInMenuItems(user, options)

    const signedOutItems = withReturnTo(signedOutMenuItems(options), currentPath)
    return withoutHeaderLinks ? excludeHeaderLinks(signedOutItems) : signedOutItems
  })
</script>

<UserMenuDropdown {items} {currentPath} align="right" compact={mobileLayout || isNativeApp()} />
